import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { APP_VERSION } from 'src/version';

@Component({
    selector: 'add-main-admin',
    templateUrl: './main-admin.component.html',
    styleUrls: ['./main-admin.component.scss'],
})
export class MainAdminComponent implements OnInit {
    version: string;

    constructor(public authService: AuthService) {
        this.version = APP_VERSION.version;
    }

    ngOnInit() {}
}
